import { graphql } from "gatsby";
import React from "react";

import BacteriaAnalysis from "../../assets/treatment/addon/icons/bacteriaAnalysis.svg";
import Beauty from "../../assets/treatment/addon/icons/beauty.svg";
import CariesRepair from "../../assets/treatment/addon/icons/cariesRepair.svg";
import CariesRiskAnalysis from "../../assets/treatment/addon/icons/cariesRiskAnalysis.svg";
import CompleteAnalysis from "../../assets/treatment/addon/icons/completeAnalysis.svg";
import Desensitization from "../../assets/treatment/addon/icons/desensitization.svg";
import TongueCleaning from "../../assets/treatment/addon/icons/tongueCleaning.svg";
import Bleaching from "../../assets/treatment/bleaching.svg";
import Combo from "../../assets/treatment/combo.svg";
import DentalHygiene from "../../assets/treatment/dentalHygiene.svg";
import OralHealthCheck from "../../assets/treatment/oralHealthCheck.svg";

type IconT =
  // Treatments
  | "Bleaching"
  | "Combo"
  | "DentalHygiene"
  | "OralHealthCheck"
  // TreatmentAddons
  | "BacteriaAnalysis"
  | "CariesRepair"
  | "CariesRiskAnalysis"
  | "Beauty"
  | "TongueCleaning"
  | "CompleteAnalysis"
  | "Desensitization";

type Type =
  | Queries.TreatmentIcon_PrismicTreatment_Fragment
  | Queries.TreatmentIcon_PrismicHiddenTreatment_Fragment
  | Queries.TreatmentIcon_PrismicTreatmentAddon_Fragment;

const Icon: React.FC<{ icon: Type; className?: string }> = ({ icon, className = "absolute right-4 top-[20.5px]" }) => {
  const name = icon?.data.icon;
  if (!name) return null;

  switch (name as IconT) {
    // Treatments
    case "Bleaching":
      return <Bleaching width="40" height="40" className={className} />;
    case "Combo":
      return <Combo width="40" height="40" className={className} />;
    case "DentalHygiene":
      return <DentalHygiene width="40" height="40" className={className} />;
    case "OralHealthCheck":
      return <OralHealthCheck width="40" height="40" className={className} />;

    // TreatmentAddons
    case "BacteriaAnalysis":
      return <BacteriaAnalysis width="40" height="40" className={className} />;
    case "CariesRepair":
      return <CariesRepair width="40" height="40" className={className} />;
    case "CariesRiskAnalysis":
      return <CariesRiskAnalysis width="40" height="40" className={className} />;
    case "Beauty":
      return <Beauty width="40" height="40" className={className} />;
    case "TongueCleaning":
      return <TongueCleaning width="40" height="40" className={className} />;
    case "CompleteAnalysis":
      return <CompleteAnalysis width="40" height="40" className={className} />;
    case "Desensitization":
      return <Desensitization width="40" height="40" className={className} />;

    default:
      console.error(`Unknown icon: ${name}`);
      return null;
  }
};

export const query = graphql`
  fragment TreatmentIcon on PrismicAllDocumentTypes {
    ... on PrismicHiddenTreatment {
      data {
        icon
      }
    }
    ... on PrismicTreatment {
      data {
        icon
      }
    }
    ... on PrismicTreatmentAddon {
      data {
        icon
      }
    }
  }
`;

export default Icon;
